<template>
  <div v-show="messages.length" ref="messagesWrapper" class="messages-wrapper">
    <div
      v-for="message in messages"
      :key="message.key"
      :class="`alert alert-${message.type} alert-dismissible`"
      role="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="removeMessage(message.key)">
        <span aria-hidden="true">&times;</span>
      </button>
      <i :class="`icon-${iconMap[message.type]}`"></i>
      <div v-html="message.text" class="error-list"></div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { getQueryParam } from '@/util/url';
import eventBus, {
  REMOVE_ALL_MESSAGES,
  REMOVE_MESSAGE,
  REMOVE_REQUEST_MESSAGES,
  SHOW_MESSAGE,
} from '../../util/eventBus';

export default {
  name: 'BaseGlobalAlert',

  data() {
    return {
      iconMap: {
        success: 'check',
        warning: 'info',
        error: 'attention',
      },
      messages: [],
    };
  },

  mounted() {
    this.checkUrlParam('success');
    this.checkUrlParam('warning');
    this.checkUrlParam('error');
    eventBus.$on(SHOW_MESSAGE, (payload) => {
      this.addMessage(payload);
    });
    eventBus.$on(REMOVE_MESSAGE, (key) => {
      this.removeMessage(key);
    });
    eventBus.$on(REMOVE_REQUEST_MESSAGES, (requestKey) => {
      this.removeRequestMessages(requestKey);
    });
    eventBus.$on(REMOVE_ALL_MESSAGES, () => {
      this.removeAllMessages();
    });
  },

  beforeDestroy() {
    eventBus.$off(SHOW_MESSAGE);
    eventBus.$off(REMOVE_MESSAGE);
    eventBus.$off(REMOVE_REQUEST_MESSAGES);
    eventBus.$off(REMOVE_ALL_MESSAGES);
  },

  methods: {
    checkUrlParam(key) {
      const messageText = getQueryParam(key);
      if (messageText) {
        this.addMessage({
          key: messageText,
          type: key,
          text: this.$t(`messages.${messageText}`),
        });
      }
    },

    async addMessage(message) {
      if (!message.key) {
        // eslint-disable-next-line no-param-reassign
        message.key = uuidv4();
      }
      for (let i = 0; i < this.messages.length; i += 1) {
        if (this.messages[i].key === message.key) {
          this.messages.splice(i, 1, message);
          return;
        }
      }
      this.messages.unshift(message);
      await this.$nextTick();
      this.$refs.messagesWrapper.scrollIntoView();
    },

    removeMessage(key) {
      this.messages = this.messages.filter((m) => m.key !== key);
    },

    removeRequestMessages(requestKey) {
      this.messages = this.messages.filter((m) => m.requestKey !== requestKey);
    },

    removeAllMessages() {
      this.messages = [];
    },
  },
};
</script>
